import React from 'react';
import { theme, style } from 'constants';
import { IcoLogo } from 'icons';
import { Scene } from 'core';

const styles = style({
  holder: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.success_color
  }
});

//    <IcoFosol size={100} color={'white'} style={{marginTop:20}}/>
const Welcome = ({ selected }) => (
  <Scene style={styles.holder}>
    <IcoLogo size={250} color={theme.success_color_lighten(0.6)} />
  </Scene>
);
export default Welcome;



// WEBPACK FOOTER //
// ./src/components/welcome.js